<template>
  <div class="home">
    <div class="filter-wrapper">
      <div style="display: flex; align-items: center">
        <div
          v-if="dataSelectLastDayValue.key === 'custom_date'"
          class="date-range-picker">
          <DatePicker
            ref="dateRangePicker"
            v-model="dateRange"
            range
            type="daterange"
            format="DD MMM YYYY"
            placeholder="Start Date - End Date"
            popper-class="green-theme"
            range-separator=" — "
            input-class="custom-input"
            :confirm="true"
            confirm-text="OK"
            :lang="{
              formatLocale: {
                firstDayOfWeek: 1,
              }
            }"
            @change="changeDateRange"
            @clear="resetToDefault">
            <template #icon-calendar>
              <font-awesome-icon :icon="dataCalendarDays" />
            </template>
          </DatePicker>
        </div>
        <v-select
          v-model="dataSelectLastDayValue"
          :options="dataSelectOptionsLastDayAndCustom"
          :filterable="false"
          :searchable="false"
          :components="{ Deselect: dataComponentDeselect }"
          placeholder="Last Days"
          striped
          :class="[
            'call-select',
            dataSelectLastDayValue ? 'call-select--value' : null
          ]"
          @input="$_ajax">
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes">
              <font-awesome-icon :icon="dataIconDown" />
            </span>
          </template>
        </v-select>

        <!-- placeholder="Local" -->
        <v-select
          v-if="timeZoneOffset !== null"
          v-model="timeZoneOffset"
          label="name"
          :components="{ Deselect: dataComponentDeselect }"
          :class="[
            'call-select',
            dataSelectLastDayValue ? 'call-select--value' : null
          ]"
          :options="computedOffsetList"
          :filterable="false"
          :searchable="false"
          :clearable="false"
          striped
          @input="$_ajax">
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              {{ option.name }}
            </div>
          </template>
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes">
              <font-awesome-icon :icon="dataIconDown" />
            </span>
          </template>
        </v-select>
        <v-select
          v-model="dataSelectProject"
          :options="computedProjectList"
          :filterable="true"
          :searchable="true"
          :components="{ Deselect: dataComponentDeselect }"
          placeholder="All Projects"
          striped
          :class="[
            'call-select call-select--proj',
            dataSelectProject ? 'call-select--value' : null
          ]">
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes">
              <font-awesome-icon :icon="dataIconDown" />
            </span>
          </template>
        </v-select>
        <!-- <h2
          v-if="timeZoneOffset !== null"
          style="margin: 0 10px">
          Timezone Offset: {{ timeZoneOffset }}
        </h2> -->
      </div>
    </div>
    <div style="display: flex; margin-bottom: 8px; gap: 8px;">
      <h2 style="margin-bottom: 0;">
        {{ computedLabel }} (This vs Last)
      </h2>
      <span
        class="last-update-wrapper">Upd: {{ computedLastUpdate | dateFilterUTC }}</span>
    </div>
    <call-card-report-detail
      :hidden-difference="dataSelectLastDayValue.key === 'custom_date'"
      :obj-card="computedStatProject" />

    <div class="table__title filter-wrapper">
      <h2>Projects ({{ dataProjectList.length || 0 }})</h2>
    </div>
    <div class="table-wrapper">
      <b-table
        :show-empty="isLoaded"
        hover
        fixed
        no-local-sorting
        :fields="dataMixinReportFields"
        :items="computedTableDataProjectListActive"
        :tbody-tr-class="rowClass"
        @row-clicked="value => onProjectActions(value, 'view')"
        @row-hovered="onHover"
        @row-unhovered="onUnHover">
        <template #empty>
          <EmptyTable />
        </template>
        <template #head(outcoming_finished_calls_count)>
          <span class="success">
            Calls
          </span>
          Finished
        </template>

        <template #head(outcoming_cancelled_calls_count)>
          <span class="danger">
            Calls
          </span>
          Cancelled
        </template>

        <template #head(auto_closed_tasks_count)>
          <span class="success">
            Closed
          </span>
          Auto Assigned
        </template>

        <template #head(auto_closed_vip_tasks_count)>
          <span class="success">
            Closed
          </span>
          VIP
        </template>

        <template #head(manually_closed_tasks_count)>
          <span class="danger">
            Closed
          </span>
          Manually
        </template>

        <template #cell(outcoming_finished_calls_count)="data">
          <span class="success">{{
            data.item.outcoming_finished_calls_count
          }}</span>
        </template>
        <template #cell(auto_closed_vip_tasks_count)="data">
          <span class="success">{{
            data.item.auto_closed_vip_tasks_count
          }}</span>
        </template>
        <template #cell(outcoming_cancelled_calls_count)="data">
          <span class="danger">{{
            data.item.outcoming_cancelled_calls_count
          }}</span>
        </template>
        <template #cell(auto_closed_tasks_count)="data">
          <span class="success">{{ data.item.auto_closed_tasks_count }}</span>
        </template>
        <template #cell(manually_closed_tasks_count)="data">
          <span class="danger">{{
            data.item.manually_closed_tasks_count
          }}</span>
        </template>

        <template #cell(isBlocked)="data">
          <font-awesome-icon
            v-if="!data.item.is_active"
            class="tabel-icon--red"
            :icon="dataIconLock" />
          <font-awesome-icon
            v-else
            class="tabel-icon--green"
            :icon="dataIconCheck" />
        </template>
        <template #cell(calls_duration)="data">
          {{ data.item.calls_duration | dateReport }}
        </template>

        <template #cell(actions)="data">
          <call-table-report-expand-actions
            v-show="data.item.actions || data.item._isToggleInactive"
            :row="data"
            @on-action="value => onProjectActions(data.item, value)" />
        </template>

        <template #row-details="row">
          <b-table
            :show-empty="isLoaded"
            fixed
            hover
            no-local-sorting
            :fields="dataMixinReportExpandedFields"
            :items="row.item.operators_kpi"
            thead-tr-class="expand-header"
            tbody-class="expand-body"
            @row-clicked="value => onActions(value, 'expand_view')"
            @row-hovered="onHover"
            @row-unhovered="onUnHover">
            <template #cell(outcoming_finished_calls_count)="data">
              <span class="success">{{
                data.item.outcoming_finished_calls_count
              }}</span>
            </template>
            <template #cell(auto_closed_vip_tasks_count)="data">
              <span class="success">{{
                data.item.auto_closed_vip_tasks_count
              }}</span>
            </template>
            <template #cell(outcoming_cancelled_calls_count)="data">
              <span class="danger">{{
                data.item.outcoming_cancelled_calls_count
              }}</span>
            </template>
            <template #cell(auto_closed_tasks_count)="data">
              <span class="success">{{
                data.item.auto_closed_tasks_count
              }}</span>
            </template>
            <template #cell(manually_closed_tasks_count)="data">
              <span class="danger">{{
                data.item.manually_closed_tasks_count
              }}</span>
            </template>

            <template #cell(isBlocked)="data">
              <font-awesome-icon
                v-if="data.item.is_blocked"
                class="tabel-icon--red"
                :icon="dataIconLock" />
              <font-awesome-icon
                v-else
                class="tabel-icon--green"
                :icon="dataIconCheck" />
            </template>
            <template #cell(calls_duration)="data">
              {{ data.item.calls_duration | dateReport }}
            </template>
            <template #cell(actions)="data">
              <call-table-report-expand-actions
                v-show="data.item.actions"
                :row="data"
                @on-action="value => onActions(data.item, 'expand_view')" />
            </template>
          </b-table>
        </template>
      </b-table>
    </div>

    <div class="table__title filter-wrapper">
      <h2>Operators ({{ dataStatReport.operators_count || 0 }})</h2>
    </div>
    <div class="table-wrapper">
      <b-table
        :show-empty="isLoaded"
        hover
        no-local-sorting
        :fields="dataMixinReportOperatorFields"
        :items="computedTableDataOperatorListActive"
        :tbody-tr-class="rowClass"
        @row-clicked="value => onActions(value, 'view')"
        @row-hovered="onHover"
        @row-unhovered="onUnHover">
        <template #empty>
          <EmptyTable />
        </template>
        <template #head(outcoming_finished_calls_count)>
          <span class="success">
            Calls
          </span>
          Finished
        </template>

        <template #head(outcoming_cancelled_calls_count)>
          <span class="danger">
            Calls
          </span>
          Cancelled
        </template>

        <template #head(auto_closed_tasks_count)>
          <span class="success">
            Closed
          </span>
          Auto Assigned
        </template>

        <template #head(auto_closed_vip_tasks_count)>
          <span class="success">
            Closed
          </span>
          VIP
        </template>

        <template #head(manually_closed_tasks_count)>
          <span class="danger">
            Closed
          </span>
          Manually
        </template>

        <template #cell(outcoming_finished_calls_count)="data">
          <span class="success">{{
            data.item.outcoming_finished_calls_count
          }}</span>
        </template>
        <template #cell(auto_closed_vip_tasks_count)="data">
          <span class="success">{{
            data.item.auto_closed_vip_tasks_count
          }}</span>
        </template>
        <template #cell(outcoming_cancelled_calls_count)="data">
          <span class="danger">{{
            data.item.outcoming_cancelled_calls_count
          }}</span>
        </template>
        <template #cell(auto_closed_tasks_count)="data">
          <span class="success">{{ data.item.auto_closed_tasks_count }}</span>
        </template>
        <template #cell(manually_closed_tasks_count)="data">
          <span class="danger">{{
            data.item.manually_closed_tasks_count
          }}</span>
        </template>

        <template #cell(isBlocked)="data">
          <font-awesome-icon
            v-if="data.item.is_blocked"
            class="tabel-icon--red"
            :icon="dataIconLock" />
          <font-awesome-icon
            v-else
            class="tabel-icon--green"
            :icon="dataIconCheck" />
        </template>
        <template #cell(calls_duration)="data">
          {{ data.item.calls_duration | dateReport }}
        </template>
        <template #cell(actions)="data">
          <call-table-report-expand-actions
            v-show="data.item.actions || data.item._isToggleBlocked"
            :row="data"
            @on-action="value => onActions(data.item, value)" />
        </template>

        <!-- expanded operator -->
        <template #row-details="row">
          <b-table
            :show-empty="isLoaded"
            hover
            no-local-sorting
            :fields="dataMixinReportOperatorExpandFields"
            :items="row.item.projects_kpi"
            tbody-class="expand-body"
            @row-clicked="value => onProjectActions(value, 'expand_view')"
            @row-hovered="onHover"
            @row-unhovered="onUnHover">
            <template #cell(actions)="data">
              <call-table-report-expand-actions
                v-show="data.item.actions"
                :row="data"
                @on-action="value => onProjectActions(data.item, 'expand_view')" />
            </template>
          </b-table>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { REPORTS_GET_TEAMS, TEAMS_GET } from '../../../store/types/actions.types';

import CallCardReportDetail from '../../../components/common/cards/reportDetailCard';
import CallTableReportExpandActions from '../../../components/desktop/CallTableReportExpandActions';
import reportsOperatorTable from '../../../mixins/table/reportsOperatorTable';
import { BTable } from 'bootstrap-vue';
import { faCheck, faLock } from '@fortawesome/pro-regular-svg-icons';
import helper from '../../../service/helper';
import selectReportPeriod from '../../../mixins/select/selectReportPeriod';
import projectTable from '../../../mixins/table/projectTable';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { faCalendarDays } from '@fortawesome/pro-light-svg-icons';

const defaultDate = [
  moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
  // moment()
  //   .year(2024)
  //   .startOf('year')
  //   .format('YYYY-MM-DD HH:mm:ss'),
  moment()
    .endOf('month')
    .format('YYYY-MM-DD HH:mm:ss')
];

export default {
  name: 'PageReportsDetail',
  components: { CallTableReportExpandActions, CallCardReportDetail, BTable },
  mixins: [projectTable, reportsOperatorTable, selectReportPeriod],
  data () {
    const projects = {
      dataProjectList: []
    };
    return {
      isLoaded: false,
      ...projects,
      dataReportList: [],
      miscDataReport: {},
      dataStatReport: {},
      dataStatProject: {},
      dataIconLock: faLock,
      dataCalendarDays: faCalendarDays,
      dataIconCheck: faCheck,
      timeZoneOffset: null,
      computedOffsetList: null,
      dataSelectProject: null,
      dataShowDeactivated: false,
      dataShowDeactivatedOperator: false,
      firstLoad: true,
      //
      startDate: null,
      endDate: null,
      defaultDateRange: [new Date(defaultDate[0]), new Date(defaultDate[1])],
      dateRange: [new Date(defaultDate[0]), new Date(defaultDate[1])],
      formattedRange: [defaultDate[0], defaultDate[1]]
    };
  },
  computed: {
    ...mapGetters({
      computedIsAdmin: 'auth/isAdmin',
      computedIsModerator: 'auth/isModerator',
      computedIsOperator: 'auth/isOperator'
    }),

    computedTableDataProjectListActive () {
      const active = [...this.dataProjectList].filter(e => e.is_active);
      const inactive = [...this.dataProjectList].filter(e => !e.is_active);

      if (inactive.length > 0) {
        active.push({
          _isToggleInactive: true,
          toggleIcon: this.dataShowDeactivated,
          id: null,
          name: this.dataShowDeactivated
            ? 'Hide inactive'
            : `Show inactive (${inactive.length})`
        });

        if (this.dataShowDeactivated) {
          active.push(...inactive);
        }
      }

      return active;
    },

    computedTableDataOperatorListActive () {
      const active = [...this.dataReportList].filter(e => !e.is_blocked);
      const inactive = [...this.dataReportList].filter(e => e.is_blocked);

      if (inactive.length > 0) {
        active.push({
          _isToggleBlocked: true,
          toggleIcon: this.dataShowDeactivatedOperator,
          is_blocked: true,
          id: null,
          name: this.dataShowDeactivatedOperator
            ? 'Hide inactive'
            : `Show inactive (${inactive.length})`
        });

        if (this.dataShowDeactivatedOperator) {
          active.push(...inactive);
        }
      }

      return active;
    },

    computedTableDataProjectListDiactive () {
      return [...this.dataProjectList].filter(e => !e.is_active);
    },

    computedProjectList () {
      return this.dataProjectList
        .filter(({ is_active }) => is_active)
        .map(({ id, name }) => {
          return { key: id, label: name };
        });
    },

    computedTeamId () {
      return this.$route.params?.reportId;
    },

    computedLastUpdate () {
      return this.miscDataReport?.stats_refreshed_at;
    },

    computedStatProject () {
      if (this.dataSelectProject?.key) {
        // console.log(this.dataStatReport.projects);

        return this.dataStatReport.projects
          .filter(({ id }) => id === Number(this.dataSelectProject?.key))[0]
          .report;
      }

      return this.dataStatReport;
    },
    computedLabel () {
      return this.dataSelectLastDayValue?.label || 'Today';
    }
  },
  async created () {
    this.$_ajax = ((options = {}) => {
      const { currentRoute: { name: pageName } = {} } = this.$router;

      const _filterKey = `_filter${pageName}`;

      if (!helper.isEmpty(this.$route.query, _filterKey)) {
        try {
          options = helper.clearObject(JSON.parse(this.$route.query[_filterKey]));

          const _arrFilter = [
            'period'
          ];

          for (const _key of _arrFilter) {
            if (!helper.isEmpty(options, _key)) {
              switch (_key) {
                case 'period':
                  this.dataSelectLastDayValue = options[_key];
                  break;
              }
            }
          }
        } catch (e) {
          console.log('Error query params');
        }
      }

      return async () => {
        this.$store.dispatch('loading/startLoading');

        try {
          if (!this.dataSelectLastDayValue) {
            this.dataSelectLastDayValue = {
              ...this.dataSelectLastDayValueDefault
            };
          }

          const { team = {} } = await this.$store.dispatch(`team/${TEAMS_GET}`, {
            params: {
              id: this.computedTeamId
            }
          });

          if (this.firstLoad) {
            this.timeZoneOffset = this.$store.state.team.utc.find(item => item.id === team.timezone_offset);
            if (team.timezone_offset === 0) {
              this.computedOffsetList = [
                { id: 0, name: this.$store.state.team.utc.find(item => item.id === 0).name }
              ];
            } else {
              this.computedOffsetList = [
                { id: this.timeZoneOffset.id, name: this.$store.state.team.utc.find(item => item.id === this.timeZoneOffset.id).name },
                { id: 0, name: this.$store.state.team.utc.find(item => item.id === 0).name }
              ];
            }
            this.firstLoad = false;
          }
          const dateRange = this.formattedRange;
          const { payload = {}, misc = {} } = await this.$store.dispatch(`report/${REPORTS_GET_TEAMS}`, {
            teamId: this.computedTeamId,
            params: {
              ...(this.dataSelectLastDayValue?.key === 'custom_date'
                ? {
                    start_timestamp: dateRange[0],
                    end_timestamp: dateRange[1]
                  }
                : { period: this.dataSelectLastDayValue?.key || 'day' }),
              timezone: this.timeZoneOffset?.id
            }
          });

          this.miscDataReport = misc;

          this.dataStatReport = payload.statTeam;

          this.dataReportList = helper.cloneDeep((payload.statTeam?.operators || [])).map((item) => {
            item.actions = false;
            return item;
          });

          this.dataProjectList = helper.cloneDeep((payload.statTeam?.projects || [])).map((item) => {
            item.actions = false;
            return item;
          });

          this.$router.replace({
            ...this.$router.currentRoute,
            query: {
              ...(this.$route.query || {}),
              [_filterKey]: JSON.stringify(helper.clearObject({
                period: this.dataSelectLastDayValue
              }))
            }
          }).catch(() => {});

          options = {};
          this.isLoaded = true;
        } finally {
          this.$store.dispatch('loading/stopLoading');
        }
      };
    })();

    this.$store.dispatch('loading/startLoading');

    await Promise.all([
      this.$_ajax()
    ]);

    this.$store.dispatch('loading/stopLoading');
  },
  methods: {
    rowClass (item) {
      if (item && item._isToggleInactive) {
        return 'toggle-inactive-row';
      }
      if (item && item._isToggleBlocked) {
        return 'toggle-inactive-row';
      }
      return '';
    },
    resetToDefault () {
      this.dateRange = [...this.defaultDateRange];
    },
    changeDateRange () {
      if (this.$refs.dateRangePicker) {
        this.$refs.dateRangePicker.closePopup();
      }
      setTimeout(() => {
        if (this.dateRange.length === 2) {
          this.formattedRange = [
            moment(this.dateRange[0]).format('YYYY-MM-DD HH:mm:ss'),
            moment(this.dateRange[1])
              .endOf('day')
              .format('YYYY-MM-DD HH:mm:ss')
          ];
          this.$_ajax();
        }
      }, 10);
    },
    // project

    async onProjectActions (item, action) {
      if (item._isToggleInactive) {
        this.dataShowDeactivated = !this.dataShowDeactivated;
        return;
      }
      const { id: projectId, is_active: isBlocked, name = '', project_id, project_name } = item;
      switch (action) {
        case 'update':
          break;
        case 'view':
          this.$router.push({
            name: 'ProjectTasks',
            params: {
              projectId
            },
            query: {
              ...(this.$route.query || {}),
              projectName: name
            }
          });
          break;
        case 'expand_view':
          this.$router.push({
            name: 'ProjectTasks',
            params: {
              projectId: project_id
            },
            query: {
              ...(this.$route.query || {}),
              projectName: project_name
            }
          });
          break;
      }
    },

    async  onActions (item, action) {
      if (item._isToggleBlocked) {
        this.dataShowDeactivatedOperator = !this.dataShowDeactivatedOperator;
        return;
      }

      const { id: userId, is_blocked: isBlocked, name = '', operator_id, operator_name } = item;
      switch (action) {
        case 'view':
          this.$router.push({
            name: 'UserDetail',
            params: {
              id: userId
            },
            query: {
              userName: name
            }
          });
          break;
        case 'expand_view':
          this.$router.push({
            name: 'UserDetail',
            params: {
              id: operator_id
            },
            query: {
              userName: operator_name
            }
          });
          break;
      }
    }
  }
};
</script>
<style lang="scss">
.filter-wrapper {
  .mx-input-wrapper {
    .custom-input {
      width: 100%;
    }
  }
  .date-range-picker {
    height: 100%;
    max-width: 220px;
    display: flex;
    align-items: center;
    background: #eeeeef;
    padding-left: 8px;
    border-radius: 8px;
    margin-right: 8px;
  }

  .custom-input {
    border: none;
    background: transparent;
    font-size: 14px;
    width: 100%;
  }
}

.toggle-inactive-row {
  cursor: pointer;
  font-weight: 600;
  background-color: #e8f5e9 !important;
  color: #2e7d32;

  td {
    border-top: 2px dashed #a5d6a7;
  }

  &:hover {
    background-color: #c8e6c9 !important;
  }
}

</style>
